import { View } from 'react-native'
import styled from 'styled-components/native'
import { VideoView } from 'expo-video'
import { LinearGradient } from 'expo-linear-gradient'

export const StyledVideo = styled(VideoView)`
  width: 100%;
  height: 100%;
  flex: 1.25;
  flex-grow: 1.25;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.welcomeScreenBackgroundSlide0};
`
export const StyledViewVideoContainer = styled(View)`
  flex-direction: column;
  width: 100%;
  flex: ${({ theme: { isBigScreen } }) => (isBigScreen ? '0.8' : '1')};
`
export const StyledLinearGradient = styled(LinearGradient)`
  height: 200px;
  width: 100%;
  margin-top: -200px;
`
